import { SVGProps } from "react";

const TrashSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20.0083 20.0083"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9587 17.509H7.05383C6.07367 17.509 5.25875 16.7543 5.18357 15.7771L4.37891 5.31641H15.6336L14.8289 15.7771C14.7537 16.7543 13.9388 17.509 12.9587 17.509V17.509Z"
      stroke="#9DA6B0"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6748 5.31528H3.33594"
      stroke="#9DA6B0"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.66055 2.5H12.35C12.868 2.5 13.2879 2.91991 13.2879 3.43789V5.31367H6.72266V3.43789C6.72266 3.18915 6.82147 2.95059 6.99736 2.7747C7.17325 2.59881 7.4118 2.5 7.66055 2.5Z"
      stroke="#9DA6B0"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33594 14.1747H11.6707"
      stroke="#9DA6B0"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TrashSvg;
